/* eslint-disable max-len */
/* eslint-disable security/detect-object-injection */

import React, { useRef, useState, useEffect } from 'react';
import { useOnClickOutside } from '../../../CommonMethods/OutsideClick';
import { DatePicker, Space } from 'antd';
import CustomDateRangePicker from '../../../components/CustomDateRangePicker';
import { Tooltip } from 'react-tooltip';

const CustomerFilter = ({
    isFilterOpen,
    setIsFilterOpen,
    handleOnClickSearch,
    handleSetDate,
    DateRange,
    DateRangeError,
    SetDateRangeError,
    DateErrorClear,
    productFilter,
    handleDatePickerValidation,
    filterValues,
    setFilterValues,
    handleApplyFilter
}) => {

    const ref = useRef();

    const [active, setActive] = useState('status')

    useOnClickOutside(ref, () => {
        // DateErrorClear()
        setIsFilterOpen(false)
    })

    useEffect(() => {

    }, [])

    const [statusKey, setSatusKey] = useState('')

    const initailState = {
        status: { Completed: false, Pending: false, Failed: false, Partial: false },
        // paymentType: { 'Card Based Payment': false, 'Crypto Based Payment': false },
        // dataRange: { create_start : '', create_end: '' },
    }

    const checkTrueProperties = (obj) => {
        const trueProperties = [];

        for (const key in obj) {
            if (obj[key] === true) {
                trueProperties.push(key);
            }
        }

        return trueProperties.join(',');
    };

    return (
        <div className="relative">
            <img
                src="/assets/images/filter.svg"
                className="cursor-pointer p-3 hover:bg-[#ECD2E0] rounded-full"
                alt=""
                data-testid="filter-btn"
                data-tooltip-id="my-tooltip-14"
                onClick={() => {setIsFilterOpen(!isFilterOpen)
                    DateErrorClear()
                }}
            />
            <Tooltip
                id="my-tooltip-14"
                place="bottom"
                content="Filter"
            />
            {isFilterOpen && <>
                <div ref={ref} className="p-4 absolute top-[40px] right-0 rounded-[4px] flex space-x-3 z-10 bg-white border border-[#F7D7E8]">
                    <div className='relative z-0'>
                        <p className='pb-3 font-[400] text-base text-[#000000B1]'>Last Transaction Date</p>
                        <div className='relative'>
                            <CustomDateRangePicker
                                start='start_date'
                                end='end_date'
                                handleSetDate={handleSetDate}
                                DateRangeError={DateRangeError}
                                setDateRangeError={SetDateRangeError}
                                DateRange={DateRange} />
                        </div>
                        <div className='mt-3 flex items-center'>
                            <button className='bg-primary px-[47.5px] py-[5px] w-1/2 text-[14px] leading-[22px] font-[400] rounded-[12px] text-[#FFFFFF]' data-testid="apply-btn" onClick={() => {
                                if (handleDatePickerValidation()) {
                                    return
                                }
                                handleApplyFilter(false);
                                setIsFilterOpen(false)
                            }}>
                                Apply
                            </button>
                            <button data-testid="clear-btn" className="text-[14px] w-1/2 font-[400] leading-[22px] text-[#731748] whitespace-nowrap mt-3" onClick={() => {
                                handleApplyFilter(true);
                                setIsFilterOpen(false)
                            }}>
                                Clear All
                            </button>
                        </div>
                    </div>
                </div>
            </>
            }
        </div>
    );
}

export default CustomerFilter;
